import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  id: "pallet",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.29102 18.5625V16.6667H18.7077V18.5625H16.4577V17.8958H11.1243V18.5625H8.87435V17.8958H3.54102V18.5625H1.29102ZM4.79102 13.5417C4.5549 13.5417 4.35699 13.4618 4.19727 13.3021C4.03754 13.1424 3.95768 12.9445 3.95768 12.7083V2.29168C3.95768 2.05557 4.03754 1.85765 4.19727 1.69793C4.35699 1.5382 4.5549 1.45834 4.79102 1.45834H15.2077C15.4438 1.45834 15.6417 1.5382 15.8014 1.69793C15.9612 1.85765 16.041 2.05557 16.041 2.29168V12.9167C16.041 13.0972 15.982 13.2465 15.8639 13.3646C15.7459 13.4826 15.5966 13.5417 15.416 13.5417H4.79102ZM5.20768 12.2917H14.791V2.70834H5.20768V12.2917ZM7.35352 6.50001H12.6452V5.27084H7.35352V6.50001Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }